
import { BaseBackgroundEffect } from '../BaseBackgroundEffect';
import { BackgroundContext } from '../BackgroundEffect';

export class PlasmaBackground extends BaseBackgroundEffect {
    public render(bc: BackgroundContext): void {
        const { ctx, width, height, config, time } = bc;
        const speed = (config.backgroundSpeed || 1.0) * 0.5;
        const complexity = config.backgroundComplexity || 1.0;

        // Use a hidden canvas for low-res plasma to save performance
        const tempCanvas = document.createElement('canvas');
        tempCanvas.width = 100;
        tempCanvas.height = 100;
        const tctx = tempCanvas.getContext('2d')!;

        const imageData = tctx.createImageData(100, 100);
        const data = imageData.data;

        const p1 = this.getPrimaryColor(bc);
        const p2 = this.getSecondaryColor(bc);

        // Convert hex to rgb
        const rgb1 = this.hexToRgb(p1);
        const rgb2 = this.hexToRgb(p2);

        for (let x = 0; x < 100; x++) {
            for (let y = 0; y < 100; y++) {
                let v = 0;
                const tx = x / 100;
                const ty = y / 100;
                
                v += Math.sin((tx * 10 * complexity) + time * speed);
                v += Math.sin((ty * 10 * complexity) + time * speed);
                v += Math.sin(((tx + ty) * 10 * complexity) + time * speed);
                v += Math.sin(Math.sqrt(tx*tx + ty*ty) * 20 * complexity + time * speed);
                
                v = (v + 4) / 8; // Normalize to 0-1
                
                const idx = (x + y * 100) * 4;
                data[idx] = rgb1.r + v * (rgb2.r - rgb1.r);
                data[idx+1] = rgb1.g + v * (rgb2.g - rgb1.g);
                data[idx+2] = rgb1.b + v * (rgb2.b - rgb1.b);
                data[idx+3] = 255;
            }
        }

        tctx.putImageData(imageData, 0, 0);
        ctx.drawImage(tempCanvas, 0, 0, width, height);
    }

    private hexToRgb(hex: string) {
        if (hex.startsWith('hsl')) {
            // Very rough HSL to RGB fallback
            return { r: 128, g: 128, b: 255 };
        }
        const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
        return result ? {
            r: parseInt(result[1], 16),
            g: parseInt(result[2], 16),
            b: parseInt(result[3], 16)
        } : { r: 0, g: 0, b: 0 };
    }
}
